import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AppStateService } from './app-state.service';
import { Router } from '@angular/router';
@Injectable()
export class RoutingGuardService {
  state = true;
  constructor(private appState: AppStateService, private router: Router) {

    this.appState.loggedIn.subscribe(
      response => {
        this.state = response;

      }

    );
  }
  canActivate() {

    if (this.state) {
      return true;
    }
    else {
      return false;
    }
  }
  canActivateChild() {
    if (this.state) {
      return true;
    }
    else {
      return false;
    }
  }

  canLoad() {

    if (this.state) {

      this.appState.setState(false);
      this.appState.setState(true);
      return true;

    }
    else {

      this.router.navigate(['']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/routing-guard.service.ts